// Sambutan pertama kali login (ditulis ulang 2026-10-12): alur lama (daftar email, tunggu setup admin,
// upload cookie) sudah tidak berlaku — channel kini dihubungkan langsung lewat login Google/TikTok/Instagram.
// Langkah & tombol menyesuaikan fitur aktif klien (fiturOn) dan langsung membuka menunya (onNav).
import React, { useEffect } from 'react';
import { colors, radius } from '../theme';

export default function WelcomeModal({ clientName, fiturOn = () => true, ugcOn = false, onNav, onClose }) {
  useEffect(() => {
    const esc = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);

  const platform = ['YouTube', fiturOn('tiktok') && 'TikTok', fiturOn('instagram') && 'Instagram'].filter(Boolean);
  const steps = [
    {
      icon: 'ti-plug-connected', nav: 'channels', cta: 'Hubungkan channel',
      title: `Hubungkan akun ${platform.join(', ').replace(/, ([^,]*)$/, ' & $1')}`,
      desc: 'Klik tombol hubungkan lalu login dengan akun yang ingin dipakai. Tidak perlu cookie atau ekstensi apa pun.',
    },
    {
      icon: 'ti-upload', nav: 'jobs', cta: 'Buat konten',
      title: 'Buat konten Shorts',
      desc: fiturOn('url_source')
        ? 'Tempel link video atau unggah file dari perangkat, pilih channel tujuan, lalu kirim. Sistem memotong, memberi branding, dan mengunggah otomatis.'
        : 'Unggah file video dari perangkat, pilih channel tujuan, lalu kirim. Sistem memproses dan mengunggah otomatis.',
    },
    {
      icon: 'ti-movie', nav: 'ugc', cta: 'UGC Compilation', off: !(ugcOn && fiturOn('ugc')),
      title: 'Kompilasi video panjang (UGC)',
      desc: 'Susun beberapa lagu jadi satu video kompilasi lengkap dengan visual & chapter — atau unggah video jadi milikmu sendiri.',
    },
    {
      icon: 'ti-clock-play', title: 'Atur jadwal kirim',
      desc: `Kirim langsung, bertahap, atau acak dalam rentang waktu tertentu supaya upload antar channel tidak serentak.${fiturOn('campaigns') ? ' Simpan grup channel sebagai Campaign agar sekali klik.' : ''}`,
    },
    {
      icon: fiturOn('analytics') ? 'ti-chart-bar' : 'ti-list-details',
      nav: fiturOn('analytics') ? 'analytics' : 'laporan',
      cta: fiturOn('analytics') ? 'Analytics' : 'Riwayat job',
      title: 'Pantau hasilnya',
      desc: fiturOn('analytics')
        ? 'Lihat status tiap upload di Riwayat job, dan perkembangan views per channel di Analytics.'
        : 'Lihat status tiap upload per channel di Riwayat job.',
    },
  ].filter(Boolean);

  const tips = [
    { icon: 'ti-refresh', text: 'Upload yang gagal karena kuota penuh atau gangguan sesaat dijadwalkan ulang otomatis — tidak perlu kirim ulang.' },
    { icon: 'ti-alert-triangle', text: 'Channel bertanda "Perlu dihubungkan ulang"? Klik Hubungkan ulang di menu Hubungkan channel.' },
    { icon: 'ti-gauge', text: 'Batas upload harian mengikuti paket & kuota YouTube, direset sekitar pukul 14.00–15.00 WIB.' },
  ];

  const buka = id => { onClose(); onNav && onNav(id); };

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="welcome-title">
        <div style={S.header}>
          <button onClick={onClose} style={S.x} aria-label="Tutup"><i className="ti ti-x"></i></button>
          <img src="/emblem-sticker.png" alt="Starhub Creative" style={{ height: 84, width: 'auto', marginBottom: 14, transform: 'rotate(-6deg)' }} />
          <h2 id="welcome-title" style={S.title}>Selamat datang{clientName ? `, ${clientName}` : ''} 👋</h2>
          <p style={S.subtitle}>Akunmu sudah aktif. Ini {steps.length} langkah singkat untuk mulai mengunggah.</p>
        </div>

        <div style={S.body}>
          <ol style={S.list}>
            {steps.map((s, i) => (
              <li key={i} style={S.step}>
                <div style={S.rail}>
                  <div style={S.num}>{i + 1}</div>
                  {i < steps.length - 1 && <div style={S.line} />}
                </div>
                <div style={{ flex: 1, minWidth: 0, paddingBottom: i < steps.length - 1 ? 18 : 0 }}>
                  <div style={S.stepTitle}><i className={`ti ${s.icon}`} style={{ fontSize: 16, color: colors.accent }}></i>{s.title}</div>
                  {s.off && <div style={S.lock}><i className="ti ti-lock" style={{ fontSize: 13 }}></i>Hubungi admin untuk mengaktifkan fitur ini</div>}
                  <div style={S.stepDesc}>{s.desc}</div>
                  {s.nav && !s.off && onNav && (
                    <button onClick={() => buka(s.nav)} style={S.link}>Buka {s.cta} <i className="ti ti-arrow-right" style={{ fontSize: 13 }}></i></button>
                  )}
                </div>
              </li>
            ))}
          </ol>

          <div style={S.tips}>
            <div style={S.tipsTitle}>Perlu diketahui</div>
            {tips.map((t, i) => (
              <div key={i} style={S.tip}>
                <i className={`ti ${t.icon}`} style={{ fontSize: 15, color: colors.textSecondary, marginTop: 1, flexShrink: 0 }}></i>
                <span>{t.text}</span>
              </div>
            ))}
          </div>

          <div style={S.support}>
            <span style={{ color: colors.textSecondary }}>Butuh bantuan?</span>
            <a href="https://t.me/FZL420" target="_blank" rel="noreferrer" style={S.supportLink}><i className="ti ti-brand-telegram"></i>@FZL420</a>
            <span style={{ color: colors.textMuted }}>·</span>
            <a href="mailto:support@starhubcreative.id" style={S.supportLink}><i className="ti ti-mail"></i>support@starhubcreative.id</a>
          </div>
        </div>

        <div style={S.footer}>
          <button onClick={() => (onNav ? buka('channels') : onClose())} style={S.primary}>Mulai: hubungkan channel</button>
          <button onClick={onClose} style={S.secondary}>Nanti saja</button>
          <div style={S.note}>Panduan lengkap selalu ada di menu <b>Panduan</b>.</div>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(17,24,39,0.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modal: { background: colors.bgCard, borderRadius: 16, width: '100%', maxWidth: 560, maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,0.18)' },
  header: { position: 'relative', padding: 'clamp(20px, 5vw, 26px) clamp(18px, 5vw, 28px) 20px', background: `linear-gradient(180deg, ${colors.accentMuted}, ${colors.bgCard})`, borderRadius: '16px 16px 0 0' },
  x: { position: 'absolute', top: 14, right: 14, width: 32, height: 32, borderRadius: 8, border: 'none', background: 'transparent', color: colors.textSecondary, fontSize: 18, cursor: 'pointer' },
  title: { fontSize: 21, fontWeight: 700, color: colors.textPrimary, margin: '0 0 6px', lineHeight: 1.3 },
  subtitle: { fontSize: 14, color: colors.textSecondary, margin: 0, lineHeight: 1.5 },
  body: { padding: '8px clamp(18px, 5vw, 28px) 4px' },
  list: { listStyle: 'none', margin: '8px 0 20px', padding: 0 },
  step: { display: 'flex', gap: 14 },
  rail: { display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 },
  num: { width: 28, height: 28, borderRadius: '50%', background: colors.accent, color: '#fff', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  line: { flex: 1, width: 2, background: colors.border, marginTop: 4 },
  stepTitle: { display: 'flex', alignItems: 'center', gap: 7, fontSize: 14.5, fontWeight: 600, color: colors.textPrimary, marginTop: 4 },
  lock: { display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, fontWeight: 600, color: colors.goldText, background: colors.goldMuted, border: `1px solid ${colors.gold}`, borderRadius: 999, padding: '2px 9px', marginTop: 6 },
  stepDesc: { fontSize: 13, color: colors.textSecondary, lineHeight: 1.6, marginTop: 4 },
  link: { marginTop: 8, padding: '5px 12px', borderRadius: 999, border: `1px solid ${colors.border}`, background: colors.bgCard, color: colors.accentText, fontSize: 12.5, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 },
  tips: { background: colors.bgCardMuted, borderRadius: radius.lg, padding: '14px 16px', marginBottom: 16 },
  tipsTitle: { fontSize: 12, fontWeight: 700, color: colors.textSecondary, textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 10 },
  tip: { display: 'flex', gap: 10, fontSize: 13, color: colors.textPrimary, lineHeight: 1.55, marginBottom: 8 },
  support: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 4 },
  supportLink: { color: colors.accentText, fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 },
  footer: { padding: '18px clamp(18px, 5vw, 28px) 24px', borderTop: `1px solid ${colors.border}`, marginTop: 16, display: 'flex', flexWrap: 'wrap', gap: 10 },
  primary: { flex: '1 1 220px', background: colors.accent, color: '#fff', padding: '12px 18px', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 14.5, cursor: 'pointer' },
  secondary: { flex: '0 1 auto', background: colors.bgCard, color: colors.textPrimary, padding: '12px 18px', border: `1px solid ${colors.borderStrong}`, borderRadius: 10, fontWeight: 500, fontSize: 14.5, cursor: 'pointer' },
  note: { flexBasis: '100%', fontSize: 12, color: colors.textSecondary, textAlign: 'center', marginTop: 2 },
};
